import React, { MouseEventHandler } from "react"
import cn from "classnames"
import Icon from "../general/Icon"

interface IconButtonProps {
  className?: string
  symbolId: SvgSymbolId;
  id?: string;
  type?: "submit" | "reset" | "button";
  onClick: MouseEventHandler<HTMLButtonElement>
  transparent?: boolean;
}

const IconButton: React.FC<IconButtonProps> = (props) => {
  const className = cn("Button Button--singleIcon", props.className, {
    "Button--transparent": props.transparent,
  });
  return (
    <button
      className={className}
      id={props.id}
      type={props.type || "button"}
      onClick={props.onClick}
    >
      <Icon className="Button-icon" symbolId={props.symbolId}/>
    </button>
  )
}

export default IconButton
